export const RQ_GET_CONSOLIDATED_REPORT_API = {
  url: 'expense/report/consolidation-report/<%= divisionId %>/<%= yearMonth %>',
  method: 'GET',
  auth: true,
};
